import $ from 'jquery';
import 'bootstrap';
import { uniq } from 'lodash';

import { cookieGetItem } from '../../cookie';
import { USER_INFO, CLASS_DOMAIN } from '../../constants';

export const init = () => {
  const userInfo = cookieGetItem(USER_INFO);
  const elBonusPoint = $('.cpa-bonusPoint-id');
  const elWarning = elBonusPoint.find('.cpa-bonusPoint-text');
  if (userInfo) {
    elWarning.removeClass('d-none');
    //elWarning.text(`您当前有：${userInfo.bonusPoint}积分，可抵扣${userInfo.bonusPoint / 10}元学费`);
    elWarning.text(
      `您当前有：${userInfo.bonusPoint}积分，CPA课程，每满899元，可用1000积分抵扣100元`
    );
  } else {
    elWarning.addClass('d-none');
    elWarning.text('');
  }
  let player = null;

  let marqueeArr = [];
  // export const onGetVideoToken = ({ courseId, bookId, bulletId, videoId, vid }) =>
  //   httpClient.get(`${apis.GET_VIDEO_TOKEN}/${courseId}/${bookId}/${bulletId}/${videoId}/${vid}`, {
  //     ignore: true,
  //   });
  // export const onGetPublicKey = () =>
  //   httpClient.get(`${apis.GET_PUBLIC_KEY}`, {
  //     ignore: true,
  //   });
  // export const GET_VIDEO_TOKEN = `${ROOT_API}/nuxt/polyv/token`;
  // export const GET_PUBLIC_KEY = `${ROOT_API}/nuxt/polyv/genPublicKey`;

  const elVideos = $('.list-group-item.list-group-item-action');
  $.each(elVideos, (i, v) => {
    const item = $(v);
    item.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      $('#mall-cpa-free-video-modal-id').modal('show');
      $('#all-cpa-staticBackdropLabel').text(item.text().trim());
      $.get(
        `/api/nuxt/polyv/token/${item.attr('data-courseid')}/${item.attr(
          'data-bookid'
        )}/${item.attr('data-bulletid')}/${item.attr('data-videoid')}/${item.attr('data-vpath')}`
      ).done((data) => {
        let playsafe = data.data;
        $.get(`/api/nuxt/polyv/genPublicKey`).done((data) => {
          let publicKey = data.data;
          let vid = item.attr('data-vpath');
          player = window.polyvPlayer({
            wrap: '#mall-cpa-polyv',
            width: '100%',
            height: '100%',
            vid: vid,
            playsafe: playsafe,
            marqueeCheck: true,
            pub: publicKey,
            speed: false,
            forceH5: true,
            hideSwitchPlayer: true,
            ignoreIE: false,
          });
          if (marqueeArr.find((v) => v == vid)) {
            return;
          }
          marqueeArr.push(vid);
          player.on(vid, async (data, plain) => {
            try {
              $.post('/api/nuxt/polyv/quickcheck', {
                enMarqueeData: data,
                enKeyIV: plain,
              }).done((res) => {
                if (res.data.status != 200) {
                  player.pushData(res, (err) => {
                    if (err) {
                      console.warn('数据有异常');
                    }
                  });
                  throw new Error('Network response was not ok.');
                }
              });
              if (res.data.status != 200) {
                player.pushData(res, (err) => {
                  if (err) {
                    console.warn('数据有异常');
                  }
                });
                throw new Error('Network response was not ok.');
              }
            } catch (e) {
              player.destroy();
              throw new Error('网络请求失败，请刷新页面重新播放');
            }
          });
        });
      });
    });
  });

  // const elVideos = $('.list-group-item.list-group-item-action');
  // $.each(elVideos, (i, v) => {
  //   const item = $(v);
  //   item.on('click', (e) => {
  //     e.preventDefault();
  //     e.stopPropagation();
  //     $('#mall-cpa-free-video-modal-id').modal('show');
  //     $('#all-cpa-staticBackdropLabel').text(item.text().trim());
  //     if (player) {
  //       player.changeVid(tem.attr('data-vpath'));
  //     } else {
  //       player = window.polyvPlayer({
  //         wrap: '#mall-cpa-polyv',
  //         width: '100%',
  //         height: '100%',
  //         vid: item.attr('data-vpath'),
  //       });
  //     }
  //   });
  // });

  $('#mall-cpa-free-video-modal-id').on('hidden.bs.modal', (e) => {
    player = null;
  });

  const coursePriceArr = [
    { id: 6550, price: 999 },
    { id: 6552, price: 999 },
    { id: 6554, price: 999 },
    { id: 6544, price: 999 },
    { id: 6542, price: 999 },
    { id: 6546, price: 999 },
  ];
  let goodsIds = [];
  let limitYear = 1;
  let Sum = '0.00';
  let currentSum = 0;
  let originalSum = 0;
  let twoYears = 0;
  let threeYears = 0;
  let discount = 0;

  const checkboxGroup1 = $('input[name="inlineCheckbox1"]');
  const checkboxGroup2 = $('input[name="inlineCheckbox11"]');
  const checkboxGroup3 = $('input[name="inlineCheckbox111"]');

  const elInlineRadio2 = $('#inlineRadio2');
  const elInlineRadio22 = $('#inlineRadio22');
  const elInlineRadio222 = $('#inlineRadio222');
  const elInlineRadio3 = $('#inlineRadio3');
  const elInlineRadio33 = $('#inlineRadio33');
  const elInlineRadio333 = $('#inlineRadio333');
  const elCpaTwoYears = $('.cpa-twoYears');
  const elCpaThreeYears = $('.cpa-threeYears');
  const elCurrentOrSum = $('.currentOrSum');

  const calCheckbox = (v) => {
    let len = v.length;
    let sum = 0;
    goodsIds = [];
    for (let i = 0; i < len; i++) {
      sum += coursePriceArr[v[i]].price;
      goodsIds.push(coursePriceArr[v[i]].id);
    }
    if (len >= 2 && len < 3) {
      // Sum = parseFloat(sum * 0.94).toFixed(2);
      // discount = parseFloat(sum * 0.06).toFixed(2);
      Sum = 1899;
      discount = 99;
      limitYear = 1;
    } else if (len == 3) {
      // Sum = parseFloat(sum * 0.82).toFixed(2);
      // discount = parseFloat(sum * 0.18).toFixed(2);
      Sum = 2499;
      discount = 498;
      twoYears = 0;
      threeYears = 0;
      limitYear = 1;
    } else if (len == 4) {
      // Sum = parseFloat(sum * 0.83).toFixed(2);
      // discount = parseFloat(sum * 0.17).toFixed(2);
      Sum = 3399;
      discount = 597;
      twoYears = 600;
      threeYears = 1000;
    } else if (len == 5) {
      // Sum = parseFloat(sum * 0.85).toFixed(2);
      // discount = parseFloat(sum * 0.15).toFixed(2);
      Sum = 4299;
      discount = 696;
      twoYears = 600;
      threeYears = 1000;
    } else if (len == 6) {
      // Sum = parseFloat(sum * 0.85).toFixed(2);
      // discount = parseFloat(sum * 0.15).toFixed(2);
      Sum = 5199;
      discount = 795;
      twoYears = 600;
      threeYears = 1000;
    } else {
      Sum = parseFloat(sum).toFixed(2);
      discount = 0;
      goodsIds = uniq(goodsIds);
    }
    originalSum = sum;
    // if (discount != 0) {
    //   $('.cpa-originalSum').text(`¥${originalSum}`);
    // } else {
    //   $('.cpa-originalSum').text('');
    // }
    goodsIds = uniq(goodsIds);

    if (twoYears != 0) {
      elInlineRadio2.prop('disabled', false);
      elInlineRadio22.prop('disabled', false);
      elInlineRadio222.prop('disabled', false);
      elInlineRadio3.prop('disabled', false);
      elInlineRadio33.prop('disabled', false);
      elInlineRadio333.prop('disabled', false);
      elCpaTwoYears.text(`+¥${twoYears}`);
      elCpaThreeYears.text(`+¥${threeYears}`);
    } else {
      elInlineRadio2.prop('disabled', true);
      elInlineRadio22.prop('disabled', true);
      elInlineRadio222.prop('disabled', true);
      elInlineRadio3.prop('disabled', true);
      elInlineRadio33.prop('disabled', true);
      elInlineRadio333.prop('disabled', true);
      elCpaTwoYears.text('');
      elCpaThreeYears.text('');
      resetRadioButton();
    }
    calRadioButton(limitYear);
  };

  const bindCheckboxChange = (i, group) => {
    let courseType = [];
    if (group == 1) {
      if (checkboxGroup1.eq(i).is(':checked')) {
        checkboxGroup2.eq(i).prop('checked', true);
        checkboxGroup3.eq(i).prop('checked', true);
        // courseType.push()
      } else {
        checkboxGroup2.eq(i).prop('checked', false);
        checkboxGroup3.eq(i).prop('checked', false);
      }
    } else if (group == 2) {
      if (checkboxGroup2.eq(i).is(':checked')) {
        checkboxGroup1.eq(i).prop('checked', true);
        checkboxGroup3.eq(i).prop('checked', true);
      } else {
        checkboxGroup1.eq(i).prop('checked', false);
        checkboxGroup3.eq(i).prop('checked', false);
      }
    } else if (group == 3) {
      if (checkboxGroup3.eq(i).is(':checked')) {
        checkboxGroup2.eq(i).prop('checked', true);
        checkboxGroup1.eq(i).prop('checked', true);
      } else {
        checkboxGroup2.eq(i).prop('checked', false);
        checkboxGroup1.eq(i).prop('checked', false);
      }
    }

    checkboxGroup1.each((i, v) => {
      if ($(v).is(':checked')) {
        courseType.push(i);
      }
    });
    calCheckbox(courseType);
  };

  for (let i = 0, l = coursePriceArr.length; i < l; i++) {
    checkboxGroup1.eq(i).change(() => bindCheckboxChange(i, 1));
    checkboxGroup2.eq(i).change(() => bindCheckboxChange(i, 2));
    checkboxGroup3.eq(i).change(() => bindCheckboxChange(i, 3));
  }

  // const calRadioButton = (v) => {
  //   limitYear = v;
  //   if (v == 2) {
  //     currentSum = (parseFloat(Sum) + twoYears).toFixed(2);
  //     elCurrentOrSum.html(`¥${currentSum}`);
  //   } else if (v == 3) {
  //     currentSum = (parseFloat(Sum) + threeYears).toFixed(2);
  //     elCurrentOrSum.html(`¥${currentSum}`);
  //   } else if (v == 1) {
  //     currentSum = parseFloat(Sum).toFixed(2);
  //     elCurrentOrSum.html(`¥${Sum}`);
  //     // resetRadioButton();
  //   }
  // };

  const calRadioButton = (v) => {
    limitYear = v;
    if (v == 2) {
      currentSum = (parseFloat(Sum) + twoYears).toFixed(2);
      elCurrentOrSum.html(`¥${currentSum}`);
      $('.cpa-originalSum').text(`¥${(parseFloat(originalSum) + twoYears).toFixed(2)}`);
    } else if (v == 3) {
      currentSum = (parseFloat(Sum) + threeYears).toFixed(2);
      elCurrentOrSum.html(`¥${currentSum}`);
      $('.cpa-originalSum').text(`¥${(parseFloat(originalSum) + threeYears).toFixed(2)}`);
    } else if (v == 1) {
      currentSum = parseFloat(Sum).toFixed(2);
      elCurrentOrSum.html(`¥${Sum}`);
      if (discount != 0) {
        $('.cpa-originalSum').text(`¥${parseFloat(originalSum).toFixed(2)}`);
      } else {
        $('.cpa-originalSum').text('');
      }
    }
  };

  const resetRadioButton = () => {
    $('input[name="inlineRadioOptions1"]').eq(0).prop('checked', true);
    $('input[name="inlineRadioOptions2"]').eq(0).prop('checked', true);
    $('input[name="inlineRadioOptions3"]').eq(0).prop('checked', true);
  };

  const bindRadioChange = (i, group) => {
    if (group == 1) {
      if ($('input[name="inlineRadioOptions1"]').eq(i).is(':checked')) {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', true);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', true);
      } else {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', false);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', false);
      }
    } else if (group == 2) {
      if ($('input[name="inlineRadioOptions2"]').eq(i).is(':checked')) {
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', true);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', true);
      } else {
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', false);
        $('input[name="inlineRadioOptions3"]').eq(i).prop('checked', false);
      }
    } else if (group == 3) {
      if ($('input[name="inlineRadioOptions3"]').eq(i).is(':checked')) {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', true);
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', true);
      } else {
        $('input[name="inlineRadioOptions2"]').eq(i).prop('checked', false);
        $('input[name="inlineRadioOptions1"]').eq(i).prop('checked', false);
      }
    }
    calRadioButton(i + 1);
  };

  for (let i = 0, l = 3; i < l; i++) {
    $('input[name="inlineRadioOptions1"]')
      .eq(i)
      .change(() => bindRadioChange(i, 1));
    $('input[name="inlineRadioOptions2"]')
      .eq(i)
      .change(() => bindRadioChange(i, 2));
    $('input[name="inlineRadioOptions3"]')
      .eq(i)
      .change(() => bindRadioChange(i, 3));
  }

  $('.cpa-to-buy').on('click', (e) => {
    if (goodsIds.length) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = `${CLASS_DOMAIN}/order/${goodsIds
        .sort()
        .join('-')}?limitYear=${limitYear}`;
    }
  });

  window.addEventListener(
    'scroll',
    () => {
      if ($('html').scrollTop() > 300) {
        $('.is-open-section-mall').addClass('is-open');
      } else {
        $('.is-open-section-mall').removeClass('is-open');
      }
    },
    true
  );
};
